import type { Urgency } from '@/shared/model'

import { Card } from './Card'
import { Icon } from './Icon'
import { Stack } from './Stack'
import { Text } from './Text'

export function AttentionCard({
  to,
  area,
  icon,
  title,
  when,
  action,
  urgency,
}: {
  to: string
  area: string
  icon: string
  title: string
  when: string | undefined
  action: string
  urgency: Urgency
}) {
  return (
    <li>
      <Card to={to} rail className={`tone--${urgency}`}>
        <Text role="eyebrow" tone="tone">
          {icon} {area}
        </Text>
        <Text role="title">{title}</Text>
        {when ? (
          <Text role="body" tone="muted">
            {when}
          </Text>
        ) : null}
        <Stack direction="row" justify="between" gap="sm">
          <Text as="span" role="body-strong" tone="accent">
            {action}
          </Text>
          <Icon size="sm">→</Icon>
        </Stack>
      </Card>
    </li>
  )
}
